export default __webpack_public_path__ + "static/media/im13.d2c3bb83.jpg";